import { createSlice } from '@reduxjs/toolkit'
import { ApiState } from "@baseTypes/baseType";
import { DashboardQueryParams } from "@pages/dashboard/phases";
import { applyExtraReducer } from "../../../weather";
import { createThunk, DashboardReqBody } from "../selector";
import { dashboardURL } from "@utils/utils";
import { CropInfo } from "../types";
import urlcat from "urlcat";

export interface CropDetalizationData {
    totalGeoZoneHa: number,
    currentSeasonHa: number,
    cultivatedArea: CropInfo[]
}

export interface DetalizationCropState extends ApiState {
    data: CropDetalizationData
}

const initialState: DetalizationCropState = {
    data: {
        totalGeoZoneHa: 0,
        currentSeasonHa: 0,
        cultivatedArea: []
    },
    apiError: undefined,
    isApiLoading: false
}

const fetchCropDetalization = createThunk<CropDetalizationData, DashboardQueryParams, DashboardReqBody>()(
    { url: dashboardURL('cropsDetailing'), method: "POST" },
    (payload, url) => ({
        url,
        data: {
            date: payload.date,
            cropRotationIds: payload.cropRotationIds || []
        }
    })
)

const cropDetalizationSlice = createSlice({
    name: 'cropDetalizationSlice',
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        applyExtraReducer(builder, fetchCropDetalization)
    },
})

export const actions = { ...cropDetalizationSlice.actions, fetchCropDetalization }
export default cropDetalizationSlice.reducer